import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)


export default {
    namespaced:true,
    state: {
        
        items:[],
        itemsGestion:[],
        itemsCese:[],
        gestionCese:[],
        seguimientoCese:[],
        spinner:true
    },
    getters: {

        Items(state){
           return state.items
        },

        ItemsGestion(state){
          return state.itemsGestion
        },
        
        ItemsCese(state){
          return state.itemsCese
        },

        GestionCese(state){
          return state.gestionCese
        },

        SeguimientoCese(state){
          return state.seguimientoCese
        },


        Spinner(state){
          return state.spinner
        }
    
    },
    mutations: {
        
        llenarItems(state , data){
         state.items = data
        },

        llenarSpinner(state , data){
          state.spinner = data
        },

        llenarItemsGestion(state,data){
          state.itemsGestion = data
        },

        llenarItemsCese(state, data){
          state.itemsCese = data
        },

        llenarGestionCese(state,data){
          state.gestionCese = data
        },
        
        llenarSeguimientoCese(state, data) {
          state.seguimientoCese = data
        }
    
    },

    
    actions: {

    Renovaciones({commit}){
        const idTrabajador = localStorage.getItem("idTrabajdor");
        axios
          .get(`Renovacion/ListarRenovacion/${idTrabajador}`)
          .then((r) => {        
            console.log(r.data)
            commit('llenarItems' , r.data)
            commit('llenarSpinner', false)
          }); 
    },

    async GestionRenovacion({commit}, payload) {
      const idTrabajador = localStorage.getItem("idTrabajdor");
      const perAno = payload?.perAno || "0";
      const perMes = payload?.perMes || "0";

      return axios
        .get(`Renovacion/ListarGestionRen/${idTrabajador}`, {
          params: { perAno, perMes }
        })
        .then((r) => {
          console.log(r.data);
          commit('llenarItemsGestion' , r.data)
          commit('llenarSpinner', false)
          return r.data; // Opcional: devolver los datos
        });
    },

    RegistroCese({commit}){
      const idTrabajador = localStorage.getItem("idTrabajdor");

      axios.get(`Cese/ListarRegistroCese/idTrabajador?idTrabajador=${idTrabajador}`).then(r=>{
        console.log(r.data)
        commit('llenarItemsCese' ,  r.data)
        commit('llenarSpinner', false)
      })
    },

    GestionCeses({commit}){
      const idTrabajador = localStorage.getItem("idTrabajdor");

      axios.get(`Cese/ListarGestionCese/idTrabajador?idTrabajador=${idTrabajador}`).then(r=>{
        console.log(r.data)
        commit('llenarGestionCese' , r.data)
        commit('llenarSpinner', false)

      })
    },


    async SeguimientoCeses({ commit }, payload) {
      const idTrabajador = localStorage.getItem("idTrabajdor");
      const perAno = payload?.perAno || "0";
      const perMes = payload?.perMes || "0";
      const busquedaIndividual = payload?.busquedaIndividual || false;
      const dni = payload?.dni || "0";

      return axios
        .get(`Cese/ListarSeguimiento`, {
          params: { idTrabajador, perAno, perMes, busquedaIndividual, dni }
        })
        .then((r) => {
          console.log('seguimineto ceses', r.data);
          commit("llenarSeguimientoCese", r.data);
          commit("llenarSpinner", false);
        });
    },
        
    },
    modules: {
    }
  }
  